import React, { useState } from 'react'
import { IUser } from 'src/services/types';
import { MessageSquare, PlusSquare } from 'feather-icons-react';
import { Tooltip } from 'reactstrap';
import './style.css'; // Assuming you have a CSS file for styles    

interface IProps {
    item: IUser;
    openModal: (item: IUser) => void; // Function to open the user modal
    openNoteModal: (item: IUser) => void; // Function to open the note modal
}

export const UserColumnItem = ({ item, openModal, openNoteModal }: IProps) => {
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const toggle = () => setTooltipOpen(!tooltipOpen);
    return (
        <div 
          className="d-flex justify-content-center align-items-center gap-2" 
        >
          <div 
            className="d-flex justify-content-center align-items-center gap-2 custom-avatar" 
            style={{cursor: 'pointer'}}
            onClick={() => openModal(item)}
          >
                <img
                    src={item?.imagePath}
                    alt="image-user"
                    className="avatar-sm rounded-circle"
                />
              <div className="custom-button">
                {item?.firstName} {item?.lastName}
              </div>
              
          </div>
          <div
            style={{cursor: 'pointer', marginLeft: '10px', padding: '3px 15px 3px'}}
            onClick={() => openNoteModal(item)} 
            className="custom-button"
            id={'Tooltip-' + item?.id}
          >
            {
              item?.note ? 
              <MessageSquare size="18" color={'#305dab'} fill={'#e2ebfb'} /> :
              <PlusSquare size="18" color={'#d1d1d1'} fill={'#f5f5f5'} />
            }
          </div>
          <Tooltip
            placement={'right'}
            isOpen={tooltipOpen}
            target={'Tooltip-' + item?.id}
            toggle={toggle}
          >
            { item?.note ? 'View note' : 'Add note' }
          </Tooltip>
      </div>
    );
}